import axios from "axios";
import ServerGridConfig from "../../../../config/ServerGridConfig";
import { convertFranchiseeViewAddress, convertParentFranchiseeViewAddress, convertTextToID } from "../../../../utils/GlobalFunction";
import { action, decorate, observable } from "mobx";

export default class ManageFranchiseeInquiryStore {
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	current_page = 1;
	list_data = null;
	viewValues = null;
	editValues = null;
	deleteValues = null;
	statusValues = null;
	dropdown_franchisee_Inquiry_list = null;
	viewLocationList = null
	agGridViewLocList = null

	// set form values to view
	setViewValues = (data) => {
		if (data) {
			data.address = convertFranchiseeViewAddress(data);
			data.p_address = convertParentFranchiseeViewAddress(data)
		}
		this.viewValues = data;
	};

	// set form values to Edit
	setEditValues = (data) => {
		this.editValues = data
	}

	// set form values to delete
	setDeleteValues = (data) => {
		this.deleteValues = data
	}

	setStatusValues = (data) => {
		this.statusValues = data
	}

	setViewLocationList = (data) => {
		this.viewLocationList = data
	}

	// Setup grid and set column size to autosize
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};

	setupGridViewLocList = (params) => {
		this.agGridViewLocList = params;
	};

	// change page size, default page size is LocalGridConfig.options.paginationPageSize
	setPageSize = (page = this.per_page) => {
		this.per_page = page;
		if (this.agGrid) {
			this.agGrid.api.paginationSetPageSize(parseInt(page));
		}
	};

	// call api to get records
	getList = (payload) => {
		return axios.post(`/organization/franchisee-inquiry/list`, payload).then(({ data }) => {
			if (data.list.data.length) {
				let startPage = (data.list.current_page - 1) * data.list.per_page;
				data.list.data.map((item, index) => {
					item.srno = startPage + index + 1;
					return null;
				});
			}
			this.list_data = data.list ? data.list.data : null;
			this.total = data.list.total;
			this.current_page = data.list.current_page;
			return data;
		});
	};

	// Filter function for no record found message
	changeFilterAndSort = (params) => {
		var final_filter = params.filterModel;
		var final_sort = params.sortModel;
		if (final_filter["status.id"]) {
			final_filter['status.id'].values = convertTextToID(final_filter['status.id'], this.dropdown_franchisee_Inquiry_list, 'name', 'id')
		}

		return { final_filter, final_sort };
	};

	// Filter function for no record found message
	onFilterChanged = (params) => {
		this.agGrid = params;
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
			this.agGrid.api.showNoRowsOverlay();
		}
		if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
			this.agGrid.api.hideOverlay();
		}
	};

	// Filter function for no record found message
	onFilterChangedViewLocList = (params) => {
		this.agGridViewLocList = params;
		if (this.agGridViewLocList && this.agGridViewLocList.api.getModel().getRowCount() === 0) {
			this.agGridViewLocList.api.showNoRowsOverlay();
		}
		if (this.agGridViewLocList && this.agGridViewLocList.api.getModel().getRowCount() > 0) {
			this.agGridViewLocList.api.hideOverlay();
		}
	};

	// Create data source to display record in table
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			getRows: (params) => {
				var filter_data = this.changeFilterAndSort(params.request);
				var payload = {
					filter_data: filter_data.final_filter,
					sort_data: filter_data.final_sort,
					per_page: params.request.endRow - params.request.startRow,
					page: Math.ceil(
						(params.request.startRow + 1) /
						(params.request.endRow - params.request.startRow)
					),
				};
				this.getList(payload).then((data) => {
					if (data.list.total === 0) {
						this.agGrid.api.showNoRowsOverlay();
					} else {
						this.agGrid.api.hideOverlay();
					}
					params.successCallback(data.list.data, data.list.total);
					var allColumnIds = [];
					if (this.agGrid && this.agGrid.columnApi && data.total) {
						this.agGrid.columnApi.getAllColumns().forEach(function (column) {
							allColumnIds.push(column.col_id);
						});
					}
				});
			},
		};
	};

	// call api to get records
	ViewData = (ID) => {
		return axios.get(`/organization/franchisee-inquiry/view/${ID}`).then(({ data }) => {
			this.setViewValues(data.view);
			return data;
		});
	};

	// Call edit api
	EditData = (ID, formdata) => {
		return axios.post(`/organization/franchisee-inquiry/edit/${ID}`, formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch(({ response: { data } }) => {
				var errors = [];
				var notify = null;
				if (data && data?.STATUS) {
					const { NOTIFICATION, ...fieldErrors } = data.STATUS;
					if (NOTIFICATION) {
						notify = NOTIFICATION[0];
					}
					Object.keys(fieldErrors).forEach((name) => {
						errors.push({ name, errors: data.STATUS[name] });
					});
				}
				return Promise.reject({ errors, notify });
			});
	};

	// Call delete api
	DeleteData = (formdata) => {
		return axios.delete(`/organization/franchisee-inquiry/delete/` + formdata.id)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ResendCredential = (formdata) => {
		return axios.get(`/organization/franchisee-inquiry/resend-credentials/` + formdata)
			.then(({ data }) => {
				if (this.agGrid) {
					this.setupGrid(this.agGrid);
				}
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	getFranchiseeInquiryList = (conditional = {}) => {
		return axios.post(`/organization/franchisee-inquiry/lov`, conditional)
			.then(({ data }) => {
				this.dropdown_franchisee_Inquiry_list = data.lov;
				return data;
			})
			.catch((response) => {
				return Promise.reject(response);
			});
	};

	ViewLocationListData = (ID) => {
		return axios.get(`/organization/franchisee-inquiry/show-location/${ID}`).then(({ data }) => {
			this.setViewLocationList(data.location);
			return data;
		});
	};
}

decorate(ManageFranchiseeInquiryStore, {
	per_page: observable,
	agGrid: observable,
	list_data: observable,
	allColumnIds: observable,
	setupGrid: action,
	setPageSize: action,
	getList: action,
	onFilterChanged: action,
	setViewValues: action,
	viewValues: observable,
	editValues: observable,
	setEditValues: action,
	dropdown_franchisee_Inquiry_list: observable,
	getFranchiseeInquiryList: action,
	deleteValues: observable,
	setDeleteValues: action,
	statusValues: observable,
	setStatusValues: action,
	viewLocationList: observable,
	setViewLocationList: action,
	agGridViewLocList: observable,
	setupGridViewLocList: action,
	onFilterChangedViewLocList: action
});
